import { NodeViewProps, NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { ActionIcon, Menu, Tooltip } from "@mantine/core";
import {
  IconColumns1,
  IconColumns2,
  IconColumns3,
  IconPlus,
} from "@tabler/icons-react";
import { IconColumns4 } from "@/components/icons/icon-columns-4";
import classes from "./cards.module.css";

const COLUMN_OPTIONS: Array<{
  value: 1 | 2 | 3 | 4;
  icon: any;
  label: string;
}> = [
  { value: 1, icon: IconColumns1, label: "1 column" },
  { value: 2, icon: IconColumns2, label: "2 columns" },
  { value: 3, icon: IconColumns3, label: "3 columns" },
  { value: 4, icon: IconColumns4, label: "4 columns" },
];

export default function CardsView(props: NodeViewProps) {
  const { node, editor, getPos, updateAttributes, selected } = props;
  const canEdit = editor.isEditable;
  const cols = (node.attrs.columns as 1 | 2 | 3 | 4) || 3;

  const onAddCard = () => {
    if (typeof getPos !== "function") return;
    const pos = getPos();
    if (pos == null) return;
    editor.chain().focus().appendCardToCards(pos).run();
  };

  const ActiveColsIcon =
    COLUMN_OPTIONS.find((o) => o.value === cols)?.icon ?? IconColumns3;

  return (
    <NodeViewWrapper
      className={classes.containerWrapper}
      data-type="cards"
      data-columns={cols}
      data-selected={selected ? "true" : undefined}
    >
      <div className={classes.grid} data-columns={cols}>
        {/* NodeViewContent with `display:contents` so the card children
            flow directly into the parent grid. */}
        <NodeViewContent as="div" className={classes.gridContents} />
      </div>

      {canEdit && (
        <button
          type="button"
          className={classes.addCard}
          onClick={onAddCard}
          aria-label="Add new card"
          contentEditable={false}
        >
          <IconPlus size={16} />
          <span>New card</span>
        </button>
      )}

      {canEdit && (
        <div className={classes.containerActions} contentEditable={false}>
          <Menu shadow="md" position="bottom-end" withinPortal>
            <Menu.Target>
              <Tooltip label="Columns" withArrow>
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  size="sm"
                  aria-label="Change column count"
                >
                  <ActiveColsIcon size={14} />
                </ActionIcon>
              </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
              {COLUMN_OPTIONS.map((o) => {
                const Icon = o.icon;
                return (
                  <Menu.Item
                    key={o.value}
                    leftSection={<Icon size={14} />}
                    onClick={() => updateAttributes({ columns: o.value })}
                  >
                    {o.label}
                  </Menu.Item>
                );
              })}
            </Menu.Dropdown>
          </Menu>
        </div>
      )}
    </NodeViewWrapper>
  );
}
